import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Checkbox, FormControlLabel, Button, Grid } from '@material-ui/core';

const AddMark = ({ open, onClose, addMark, saveMark, stageRef, markData, gridScaleX, gridScaleY, dxfScale }) => {
    const [x, setX] = useState('');
    const [y, setY] = useState('');
    const [step, setStep] = useState(10);
    const [rings, setRings] = useState(15);
    const [snap, setSnap] = useState(false);
    const [show, setShow] = useState(true);

    useEffect(() => {
        // console.log('Mark editor open state changed', open, markData);
        if (open) {
            const scaleX = gridScaleX * dxfScale;
            const scaleY = gridScaleY * dxfScale;
            setX(markData?.x != null ? (Number(markData.x) / scaleX) : '');
            setY(markData?.y != null ? (Number(markData.y) / scaleY) : '');
            setStep(markData?.step || 10);
            setRings(markData?.rings || 15);
            setSnap(markData?.snap || false);
            setShow(markData?.show ?? true);
            console.log('Mark data loaded', markData);
        }

        if (Object.keys(markData).length === 0) {
            handleRecenter();
        }
    }, [open, markData]);

    const handleRecenter = () => {
        // console.log('Recentering mark');

        const stage = stageRef.current;
        const stageWidth = stage.attrs.width || 0;
        const stageHeight = stage.attrs.height || 0;
        const stageScaleX = stage.attrs.scaleX || 1;
        const stageScaleY = stage.attrs.scaleY || 1;
        const stageX = stage.attrs.x || 0;
        const stageY = stage.attrs.y || 0;

        console.log('Stage dimensions:', stageWidth, stageHeight, 'Scale:', stageScaleX, stageScaleY, 'Position:', stageX, stageY);

        const worldX = (((stageWidth / 2 - stageX) / stageScaleX) / dxfScale) / gridScaleX;
        const worldY = (((stageHeight / 2 - stageY) / stageScaleY) / dxfScale) / gridScaleY;
        setX(Math.round(worldX * 100) / 100);
        setY(Math.round(worldY * 100) / 100);
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === 'x') setX(value);
        else if (name === 'y') setY(value);
        else if (name === 'step') setStep(value);
        else if (name === 'rings') setRings(value);
        else if (name === 'snap') setSnap(checked);
        else if (name === 'show') setShow(checked);
    };

    const handleSubmit = () => {
        const centerX = parseFloat(x) * gridScaleX * dxfScale;
        const centerY = parseFloat(y) * gridScaleY * dxfScale;
        const stepValue = parseFloat(step);
        const ringsValue = parseInt(rings, 10);

        saveMark({ x: centerX, y: centerY, step: stepValue, rings: ringsValue, snap, show });
        onClose();
    }

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Mark Editor</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>

                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={show}
                                    onChange={handleChange}
                                    name="show"
                                    color="primary"
                                />
                            }
                            label="Show Mark"
                        />
                    </Grid>

                    <Grid item xs={4.5}>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="X"
                            type="number"
                            fullWidth
                            variant="outlined"
                            value={x}
                            onChange={handleChange}
                            name="x"
                            inputProps={{ step: 'any' }}
                        />
                    </Grid>
                    <Grid item xs={4.5}>
                        <TextField
                            margin="dense"
                            label="Y"
                            type="number"
                            fullWidth
                            variant="outlined"
                            value={y}
                            onChange={handleChange}
                            name="y"
                            inputProps={{ step: 'any' }}
                        />
                    </Grid>
                    <Grid item xs={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => handleRecenter()}
                            style={{
                                minHeight: '40px',
                                padding: '6px 16px'
                            }}
                        >
                            Recenter
                        </Button>
                    </Grid>

                    <Grid item xs={4.5}>
                        <TextField
                            margin="dense"
                            label="Step"
                            type="number"
                            fullWidth
                            variant="outlined"
                            value={step}
                            onChange={handleChange}
                            name="step"
                            inputProps={{ step: 'any' }}
                        />
                    </Grid>

                    <Grid item xs={4.5}>
                        <TextField
                            margin="dense"
                            label="Number of Rings"
                            type="number"
                            fullWidth
                            variant="outlined"
                            value={rings}
                            onChange={handleChange}
                            name="rings"
                            inputProps={{ step: 'any' }}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={snap}
                                    onChange={handleChange}
                                    name="snap"
                                    color="primary"
                                />
                            }
                            label="Snap"
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">Cancel</Button>
                <Button onClick={handleSubmit} color="primary">Save</Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddMark;
